@if (activeDomain !== defaultDomain) {
  <div>
    <button
      class="btn-transparent text-dark pinned-indicator"
      (click)="selectDomain()"
      (keydown.enter)="selectDomain()">
      <i placement="left" ngbTooltip="Login Domain" class="icon icon-home"></i>
    </button>
  </div>
}
